import { render } from "./Segmentacao.vue?vue&type=template&id=499e360d&scoped=true"
import script from "./Segmentacao.vue?vue&type=script&lang=js"
export * from "./Segmentacao.vue?vue&type=script&lang=js"

import "./Segmentacao.vue?vue&type=style&index=0&id=499e360d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-499e360d"]])

export default __exports__